/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import Connect from "../connection/Connect";
import translations from "./translations.json";
import CryptoJS from "crypto-js";
const Context = React.createContext();

const ProviderContext = ({ children }) => {
  const urlVision = process.env.REACT_APP_VISIONMCP;
  const tercios = [1 / 3, 2 / 3, 3 / 3];
  const [userContext,setUserContext] = useState(null);
  const videoCurrentSession = useRef(null);
  const infoSession = useRef(null);
  const infoSavedSession = useRef(null);
  const currentFPS = useRef(null);
  const CrudApiRef = useRef(new Connect());
  const CrudApi = CrudApiRef.current;
  const listOfPlayers = useRef([]);
  const currentSession = useRef(null);
  const currentPlay = useRef(null)
  const isSaveCurrentSession = useRef(false)
  const currentDevice = useRef(null)
  const [customsUser,setCustomsUser] = useState(null)
  const [language, setLanguage] = useState("es");

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "user") {
        if (!event.newValue) {
          setUserContext(null);
          listOfPlayers.current = [];
          setCustomsUser(null);
          infoSession.current = null;
          videoCurrentSession.current = null;
          currentSession.current = null;
        } else {
          // Se inició sesión o cambió el usuario en otra pestaña
          try {
            const bytes = CryptoJS.AES.decrypt(
              event.newValue,
              `${process.env.TOKEN}`
            );
            const decryptedUser = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            
            if (decryptedUser) {
              restoreSession(decryptedUser);
              // Limpiar datos del usuario anterior para forzar recarga
              listOfPlayers.current = [];
              setCustomsUser(null);
              infoSession.current = null;
              videoCurrentSession.current = null;
              currentSession.current = null;
            }
          } catch (error) {
            console.error("Error al sincronizar usuario entre pestañas:", error);
          }
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      setLanguage(savedLanguage);
    }
  }, []);
  const currentCalibration = useRef(null)
  const calibrationBackground = useRef(null)
  const MINIO_ACCESS_KEY = process.env.REACT_APP_MINIO_ACCESS_KEY
  const MINIO_SECRET_KEY = process.env.REACT_APP_MINIO_SECRET_KEY
  const MINIO_ENDPOINT = process.env.REACT_APP_MINIO_URL
  const MINIO_PORT = process.env.REACT_APP_MINIO_PORT
  const MINIO_BUCKET = process.env.REACT_APP_MINIO_BUCKET
  const listOfImages = [
    "/assets/calibrations/calibration-example.png",
    "/assets/calibrations/calibration-mark-1.png",
    "/assets/calibrations/calibration-mark-2.png",
    "/assets/calibrations/calibration-mark-3.png",
    "/assets/calibrations/calibration-mark-4.png",
    "/assets/calibrations/calibration-mark-5.png",
    "/assets/calibrations/calibration-mark-6.png",
  ];

  const translate = (key) => {
    return translations[language]?.[key] || key;
  };
  const preloadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        resolve(img);
      };
      img.onerror = img.onabort = () => {
        reject(src);
      };
    });
  };
  const showSessionType = (type) => {
    switch (type) {
      case "reactive":
        return "VCM Simple";
      case "discriminative":
        return "VCM Discriminativa";
      case "applied":
        return "VCM Aplicada";
      case 'evaluative':
        return 'Evaluativa'
      default:
        return "No type";
    }
  }

  const preloadImages = (list) => {
    list.forEach((image) => {
      preloadImage(image).catch(() => {});
    });
  };

  const login = async (email, password) => {
    try {
      const response = await CrudApi.post("login", { email, password });
      return response;
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      throw error;
    }
  };
  const restoreSession = (decryptedUser) => {
    setUserContext(decryptedUser);
    CrudApi.setToken(decryptedUser.token);
  };


  useEffect(() => {
    preloadImages(listOfImages);
  }, []);

  return (
    <Context.Provider
      value={{
        urlVision,
        userContext,
        setUserContext,
        videoCurrentSession,
        isSaveCurrentSession,
        infoSession,
        infoSavedSession,
        currentFPS,
        currentDevice,
        CrudApi,
        listOfPlayers,
        currentSession,
        currentPlay,
        customsUser,
        currentCalibration,
        calibrationBackground,
        setCustomsUser,
        MINIO_ACCESS_KEY,
        MINIO_SECRET_KEY,
        MINIO_ENDPOINT,
        MINIO_PORT,
        MINIO_BUCKET,
        preloadImages,
        showSessionType,
        tercios,
        translate,
        setLanguage,
        language,
        login,
        restoreSession
      }}
    >
      {children}
    </Context.Provider>
  );
};

export { Context, ProviderContext };
